export const acceptedFileTypesArray = ['image/png', 'image/jpg', 'image/jpeg'];
export const acceptedFileTypes = acceptedFileTypesArray.join(', ');
